'use client';
import { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faCopy } from '@fortawesome/free-solid-svg-icons';
import { copyToClipboard } from '@/lib/utils/commonUtils';
import copy from '../assets/copy.svg';
import { IconProp } from '@fortawesome/fontawesome-svg-core';

export default function CopyButton({ content }: { content: string }) {
  const [showCheck, setShowCheck] = useState(false);

  const onClick = (e) => {
    //only available HTTPS
    navigator.clipboard.writeText(content).then(
      () => {
        // Success
        setShowCheck(true);
        setTimeout(() => {
          setShowCheck(false);
        }, 250);
      }
    );

  };

  return (
    <button
      type="button"
      className="hover:opacity-50 mr-2 text-slate-400 text-sm"
      onClick={onClick}
    >
      {showCheck ? (
        <i className="mio">check</i>
      ) : (
        <i className="mio">content_copy</i>
      )}
    </button>
  );
}
